import Home from 'js/pages/home/index.js'
import Goodbye from 'js/pages/goodbye/index.js'
import Recharge from 'js/pages/recharge/index.js'
import News from 'js/pages/news'
import Profile from 'js/pages/profile/index.js'
import Faqs from 'js/pages/faqs/index.js'

// META:
// forbiddenWithOneMunicipality: ruta prohibida si sólo hay 1 municipio

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      mixinLayout: true,
      watchPosition: true,
      forbiddenWithOneMunicipality: true
    }
  },
  {
    path: '/faqs',
    name: 'faqs',
    component: Faqs,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  },
  {
    path: '/news/:slug?',
    name: 'news',
    component: News,
    meta: {
      layoutInfo: true,
      layout: 'default',
      forbiddenWithOneMunicipality: true
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: Recharge,
    meta: {
      layoutInfo: true,
      forbiddenWithOneMunicipality: true
    }
  },
  {
    path: '/:municipality_id/:media_code/:media_type/recharge',
    name: 'recharge-data',
    component: Recharge,
    meta: {
      layoutInfo: true,
      forbiddenWithOneMunicipality: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      layoutInfo: true,
      layout: 'default',
      auth: true
    }
  },
  {
    path: '/goodbye',
    name: 'goodbye',
    component: Goodbye,
    meta: {
      layoutInfo: true,
      layout: 'default'
    }
  }
]
